import React, { useEffect, useState, useCallback, useMemo } from "react";
import { useTranslation } from "react-i18next";

import { useHttp } from "hooks/http.hook";
import NewsCard from "../Main/NewsSection/NewsCard";
import Loading from "../../Loading";
import PageTitle from "components/common/Layout/PageTitle";
import { getDayMounthYear } from "helpers/date";

import BackButton from "components/common/BackButton";
import { ITEMS_PER_PAGE } from "constants/settings";
import { NEWS } from "endpointsConst";

import styles from "./allNews.module.scss";

export default function AllNews() {
    const [news, setNews] = useState(null);
    const { request, loading } = useHttp();
    const { t } = useTranslation();

    const loadNews = useCallback(
        (offset = 0) => {
            request(`${NEWS}?offset=${offset}&limit=${ITEMS_PER_PAGE}`).then((res) => {
                setNews({
                    items: [...(news ? news.items : []), ...res.data.items],
                    total_count: res.data.total_count,
                });
            });
        },
        [news, request],
    );

    useEffect(() => {
        if (!news) {
            loadNews();
        }
    }, [loadNews, news]);

    const onMoreNewsClick = useCallback(() => {
        loadNews(news.items.length);
    }, [loadNews, news]);

    const isNewsOver = useMemo(() => news && news.total_count <= news.items.length, [news]);

    return (
        <div className={styles.page}>
            <BackButton />
            <PageTitle>{t("news.heading")}</PageTitle>
            {news && news.items.length > 0 ? (
                <div className={styles.grid}>
                    {news.items.map((item) => (
                        <NewsCard
                            key={item.id}
                            title={item.title}
                            date={getDayMounthYear(item.creation_date || item.created_at)}
                            description={item.description}
                            imageUrl={item.preview || null}
                            to={`/news/${item.slug || item.id}`}
                        />
                    ))}
                </div>
            ) : (
                news && news.items.length === 0 && !loading && t("news.empty")
            )}
            {!isNewsOver && !loading && (
                <div className={styles.loadMore}>
                    <button
                        className={styles.loadMoreButton}
                        type="button"
                        onClick={onMoreNewsClick}
                    >
                        {t("news.more")}
                    </button>
                </div>
            )}
            {loading && <Loading />}
        </div>
    );
}
